import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-aul-000-24",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./aul-000-24.component.html",
  styleUrl: "./aul-000-24.component.scss",
})
export class Aul00024Component implements OnChanges {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_000_24;
    }
  }
}
